<template>
  <div>
    <div class="banner"></div>
    <div class="hos-body">
      <Breadcrumb class="bread"
                  separator=">">
        <BreadcrumbItem to="/">
          <img class="bread-icon"
               src="../assets/images/icon-location.png" />首页
        </BreadcrumbItem>
        <BreadcrumbItem to="/internationalIndex">海外医疗</BreadcrumbItem>
        <BreadcrumbItem v-if="ABreadCrumbsText(type)">
          <span class="breadcrumb-item-self"
                @click="aaa">{{type | BreadCrumbsText}}</span>

        </BreadcrumbItem>
        <BreadcrumbItem class="bread-last">权威医院</BreadcrumbItem>
      </Breadcrumb>
      <!-- <Bread class="bread"/>   -->
      <Search class="search"
              @searchResult="searchResult"
              :type="type"
              :country="country" />
      <router-link :to="{name: 'HospitalInfo',params:{ id: h.id} }"
                   target="_blank"
                   class="hospital-list"
                   v-for="(h,index) in list"
                   :key="index">
        <img class="hos-cover"
             :src="baseURL + h.hospital_img"
             alt="">
        <div class="hos-info">
          <h5 class="hos-name"
              v-html="setDoctorName(h.name)"></h5>
          <!-- <p class="hos-rank">排名：暂无</p> -->
          <h6 class="hos-good">优势：
            <span v-for="(department,ind) in h.department_name"
                  :key="ind">{{department}}</span>
          </h6>
          <p class="hos-txt">
            <span v-html="h.easy_brief"></span>
          </p>
        </div>
      </router-link>
      <div class="page-box text-center">
        <Page class-name="pages"
              :total="total"
              prev-text="上一页"
              next-text="下一页"
              show-elevator
              show-total
              :page-size="15"
              @on-change="changePage" />
      </div>
    </div>
  </div>
</template>
<script>
// import Bread from '@/components/Bread.vue'
import Search from '@/components/SearchOfHospital.vue'
import * as apis from '@/api/hospital'
import demo from "@/assets/images/hospital/demo2.jpg"
import { baseURL } from "@/api/axios"
export default {
  data () {
    return {
      demo,
      baseURL,
      total: 0,
      list: [

      ],
      hospital: {
        // state_id: 0,
        // area_id: 0,
        hospital_type_id: 0,
        // department_id: 0,
        disease_id: []
      },
      type: '',
      country: 0,
      pageTitle: ''
    }

  },
  components: {
    // Bread,
    Search
  },
  created () {
    this.type = this.$route.params.type;
    this.country = Number(this.$route.params.hospitalType)
    this.pageTitle = this.setPageTitle(this.country) ? this.setPageTitle(this.country) : '医院列表'
    document.title = this.setPageType(this.type)
  },
  mounted () {
    this.hospital.hospital_type_id = this.$route.params.hospitalType;
    this.getHospitalList(1);
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        // 出国看病选择国家触发
        this.getHospitalList(1)
        this.type = this.$route.params.type;
        this.country = Number(this.$route.params.hospitalType)
        this.pageTitle = this.setPageTitle(this.country) ? this.setPageTitle(this.country) : ''
        // console.log(this.pageTitle)
        document.title = this.setPageType(this.type) + '-' + this.pageTitle + this.setPageTypeTitle(this.type)

      },
      deep: true
    }
  },
  methods: {
    getSimpleText (html) {
      var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '');//执行替换成空字符
      return msg;
    },
    async getHospitalList (page) {
      try {
        let data = {
          page: page,
          state_id: this.hospital.state_id,
          area_id: this.hospital.area_id,
          department_id: this.hospital.department_id,
          disease_id: this.hospital.disease_id,
          keyword: this.hospital.keyword,
          hospital_type_id: this.hospital.hospital_type_id
        };
        let res = await apis.getAllHospitalList(data);
        if (res.code == 200) {
          this.list = res.data.data;
          this.list.forEach(item => {
            item.brief = this.getSimpleText(item.easy_brief);
          })
          this.total = res.data.total;
          window.scrollTo(0, 0);
        }
      } catch (e) {
        console.log(e)
      }
    },
    changePage (index) {
      this.getHospitalList(index)
    },
    searchResult (val) {
      this.hospital = { ...val };
      this.setPageType(this.type)
      this.getHospitalList(1);
    },
    aaa () {
      this.$router.go(-1);//返回上一层
    },
    setPageTitle (type) {
      if (type == 1) {
        return '日本'
      } else if (type == 8) {
        return '瑞士'
      } else if (type == 3) {
        return '德国'
      } else if (type == 9) {
        return '新加坡'
      } else if (type == 4) {
        return '意大利'
      } else if (type == 12) {
        return '美国'
      }
    },
    setPageType (type) {
      if (type == 'fwlx') {
        this.hospital.hospital_type_id = 1
        return '日本医院-美国医院-德国医院-意大利医院-新加坡医院-瑞士医院-威马捷'
      } else if (type == 'index') {
        this.hospital.hospital_type_id = 0
        return '日本医院-美国医院-德国医院-意大利医院-新加坡医院-瑞士医院-威马捷'
      } else if (type == 'jmtj') {
        this.hospital.hospital_type_id = 2
        return '海外体检-精密体检-早癌筛查-日本体检-新加坡体检-香港体检-威马捷'
      } else if (type == 'yczx') {
        this.hospital.hospital_type_id = 3
        return '海外医疗-出国看病-远程咨询-第二诊疗-二次诊疗-远程视频-威马捷'
      } else if (type == 'ksl') {
        this.hospital.hospital_type_id = 4
        return '海外医疗-抗衰老-日本干细胞-瑞士干细胞-威马捷'
      } else if (type == 'xjyl') {
        this.hospital.hospital_type_id = 6
        return '海外医疗-出国看病-重离子治疗-质子治疗-干细胞治疗-基因治疗-威马捷'
      } else if (type == 'jbzt') {
        this.hospital.hospital_type_id = 5
        return '海外医疗-出国看病-癌症-肿瘤-心血管-威马捷'
      } else if (type == 'fwal') {
        this.hospital.hospital_type_id = 7
        return '服务案例-海外医疗-出国看病-远程咨询-二次诊疗-第二诊疗-威马捷'
      }
    },
    setPageTypeTitle (type) {
      if (type == 'fwlx') {
        return '医疗'
      } else if (type == 'jmtj') {
        return '体检'
      } else if (type == 'yczx') {
        return '咨询'
      } else if (type == 'ksl') {
        return ''
      } else if (type == 'xjyl') {
        return ''
      } else if (type == 'jbzt') {
        return ''
      } else if (type == 'fwal') {
        return ''
      }
    },

    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    },
    ABreadCrumbsText (type) {
      if (type == 'fwlx') {
        return '出国看病'
      } else if (type == 'index') {
        return ''
      } else if (type == 'jmtj') {
        return '精密体检'
      } else if (type == 'yczx') {
        return '远程咨询'
      } else if (type == 'ksl') {
        return '抗衰老'
      } else if (type == 'xjyl') {
        return '先进医疗'
      } else if (type == 'jbzt') {
        return '疾病专题'
      } else if (type == 'fwal') {
        return ''
      }
    },
  },
  filters: {
    BreadCrumbsText (type) {
      if (type == 'fwlx') {
        return '出国看病'
      } else if (type == 'index') {
        return ''
      } else if (type == 'jmtj') {
        return '精密体检'
      } else if (type == 'yczx') {
        return '远程咨询'
      } else if (type == 'ksl') {
        return '抗衰老'
      } else if (type == 'xjyl') {
        return '先进医疗'
      } else if (type == 'jbzt') {
        return '疾病专题'
      } else if (type == 'fwal') {
        return ''
      }
    },
  }
}
</script>
<style lang="less" scoped>
.banner {
  height: 250px;
  background: url('../assets/images/hospital/banner2.png') no-repeat center;
  background-size: 100% 250px;
}
.hos-body {
  width: 970px;
  margin: 0 auto;
}
.bread {
  margin: 30px 0;
}
.search {
  margin-bottom: 30px;
}
.hospital-list {
  display: block;
  border: 1px solid #dcdcdc;
  background: #fff;
  width: 970px;
  padding: 25px;
  margin-bottom: 20px;
  .hos-cover {
    width: 300px;
    height: 220px;
    margin-right: 20px;
  }
  .hos-info {
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 500px;
    vertical-align: top;
    .hos-name {
      font-size: 24px;
      color: #333130;
      line-height: 44px;
      font-weight: normal;
      margin-bottom: 16px;
    }
    .hos-rank {
      font-size: 18px;
      color: #ae1e10;
      line-height: 22px;
      margin-bottom: 20px;
    }
    .hos-good {
      width: 100%;
      font-size: 18px;
      color: #333130;
      line-height: 22px;
      font-weight: normal;
      margin-bottom: 6px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      // white-space: nowrap;
      // overflow: hidden;
      // text-overflow: ellipsis;
      span {
        display: inline-block;
        min-width: 116px;
        height: 40px;
        background: #f1f1f1;
        color: #333130;
        font-size: 16px;
        line-height: 40px;
        text-align: center;
        margin-right: 6px;
        margin-bottom: 20px;
        padding: 0 10px;
      }
    }
    .hos-txt {
      font-size: 16px;
      color: #797576;
      line-height: 26px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }
  }
}
.page-box {
  margin: 54px 0 108px;
}
</style>
